import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Pages } from '../utils/constants';
import { getUser } from '../utils/auth';

AdminRoute.propTypes = {
    component: PropTypes.func.isRequired,
}

function AdminRoute({ component: Component, ...rest }) {
    const user = getUser();
    return <Route {...rest} render={(props) => (
        user && user.role == 'admin' ?
            <Component {...props} /> :
            <Redirect to={Pages.HOME} />
    )} />
}

export default AdminRoute;